import React from 'react';
import { Typography } from '@mui/material';
import { OrderInfo } from 'common/types';
import { useTranslation } from 'services/localization/useTranslation';
import useShopFormat from 'hooks/useShopFormat';

interface Props {
	rentalInfo: OrderInfo;
}
const CompletedRentalCardStatus = (props: Props) => {
	const { rentalInfo } = props;
	const { t } = useTranslation();
	const { localFormat } = useShopFormat();
	const markedAsReturnedTime = rentalInfo.endDateReturned
		? localFormat(rentalInfo.endDateReturned, 'ddd D.M., HH:mm')
		: '';

	return rentalInfo.activeState !== 'RENT_CANCEL' ? (
		<React.Fragment>
			<Typography variant="body1" align="right">
				{markedAsReturnedTime}
			</Typography>
		</React.Fragment>
	) : (
		<React.Fragment>
			<Typography variant="body1" align="right" color="textSecondary">
				{t('individualRental.rent_cancel.rentalCancelled', 'Rental canceled')}
			</Typography>
			<Typography variant="body2" align="right">
				{markedAsReturnedTime}
			</Typography>
		</React.Fragment>
	);
};

export default CompletedRentalCardStatus;
